import React from "react";
import { Button } from "../Button";
import "./CustomerThanks.css";

export interface CustomerThanksProps {
  loading?: boolean;
  isRemote?: boolean | null | undefined;
  onComplete: React.MouseEventHandler<HTMLButtonElement>;
  t: Function;
}

export default function CustomerThanks({
  loading,
  isRemote,
  onComplete,
  t
}: CustomerThanksProps) {
  let labels;
  if (isRemote) {
    labels = {
      title: "customer.remote.thanks.page.title",
      body: "customer.remote.thanks.page.body",
      button: "customer.remote.thanks.page.continue"
    };
  } else {
    labels = {
      title: "customer.thanks.page.title",
      body: "customer.thanks.page.body",
      button: "general.buttons.continue.label"
    };
  }
  return (
    <div className="customer-thanks">
      <h3 className="customer-thanks-title">{t(labels.title)}</h3>
      <div className="customer-thanks-body">
        <p>
          {t(labels.body, {
            complete: t("customer.thanks.buttons.continue.label")
          })}
        </p>
      </div>
      <div className="button-group">
        <Button
          label={t(labels.button)}
          theme="primary"
          shape="solid"
          className="button-role-submit"
          onClick={onComplete}
          disabled={loading}
        />
      </div>
    </div>
  );
}
